import React, { useContext } from "react";

import MenuItem from "@material-ui/core/MenuItem";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import { Menu } from "@material-ui/core";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { EditingMessageContext } from "../../context/EditingMessage/EditingMessageContext";
import toastError from "../../errors/toastError";

const EDIT_TIME_LIMIT_MS = 15 * 60 * 1000; // 15 minutos

const MessageOptionsMenu = ({ message, menuOpen, handleClose, anchorEl, ticket }) => {
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const { setEditingMessage } = useContext(EditingMessageContext);

  const hanldeReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  const handleEditMessage = () => {
    setEditingMessage(message);
    handleClose();
  };

  const supportsEdit = ticket?.whatsapp?.tipoConexao === "baileys";
  const isWithin15Min =
    message?.createdAt &&
    Date.now() - new Date(message.createdAt).getTime() < EDIT_TIME_LIMIT_MS;
  const canEdit =
    message?.fromMe &&
    !message?.isDeleted &&
    message?.mediaType === "text" &&
    supportsEdit &&
    isWithin15Min;

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleClose}
      >
        {canEdit && (
          <MenuItem onClick={handleEditMessage}>
            Editar mensagem
          </MenuItem>
        )}
        <MenuItem onClick={hanldeReplyMessage}>
          {i18n.t("messageOptionsMenu.reply")}
        </MenuItem>
      </Menu>
    </>
  );
};

export default MessageOptionsMenu;
